import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export function shouldShowTitle(offer: IOfferSchema) {
  const { title, valueAddedServices } = offer;

  if (!valueAddedServices) {
    return false;
  }

  const { isTop3, isPremium } = valueAddedServices;

  return (isTop3 || isPremium) && typeof title === 'string' && title.trim().length > 0;
}
